@if (detail) {
  <ion-card class="form">
    <ion-list lines="none" class="ion-padding">
      @if (detail.deviceName) {
        <ion-item>
          <ion-label position="stacked" class="read">{{
            'shop_device' | translate
          }}</ion-label>
          <ion-text>{{ detail.deviceName }}</ion-text>
        </ion-item>
      }
      @if (detail.amountRemaining) {
        <ion-item>
          <ion-label position="stacked" class="read">{{
            'shop_amountRemaining' | translate
          }}</ion-label>
          <ion-text>{{ detail.amountRemaining }}</ion-text>
        </ion-item>
      }
      <ion-item>
        <ion-label position="stacked" class="read">{{
          'shop_price' | translate
        }}</ion-label>
        @if (detail.price) {
          <ion-text>&euro; {{ detail.price }}</ion-text>
        } @else {
          <ion-text>{{ 'shop_free' | translate }}</ion-text>
        }
      </ion-item>
      <ion-item>
        <ion-label position="stacked" class="read">{{
          'shop_timeSpan' | translate
        }}</ion-label>
        <ion-text>{{
          detail.monthsValid
            ? (detail.monthsValid | formatInMonths)
            : ('shop_unlimited' | translate)
        }}</ion-text>
      </ion-item>
      @if (detail.validUntil) {
        <ion-item>
          <ion-label
            position="stacked"
            class="read"
            [color]="detail.isExpired ? 'danger' : ''"
            >{{
              (detail.dateCancelled || !detail.price || detail.isExpired
                ? 'shop_validUntil'
                : 'shop_nextPayment'
              ) | translate
            }}</ion-label
          >
          <ion-text [color]="detail.isExpired ? 'danger' : ''">{{
            detail.validUntil | date: 'longDate'
          }}</ion-text>
          @if (detail.isExpired) {
            <ion-note slot="end" color="danger">{{
              'shop_expired' | translate
            }}</ion-note>
          }
        </ion-item>
      }
      @if (detail.dateCancelled) {
        <ion-item>
          <ion-label position="stacked" class="read" color="danger">{{
            'shop_dateCancelled' | translate
          }}</ion-label>
          <ion-text color="danger">{{
            detail.dateCancelled | date: 'longDate'
          }}</ion-text>
        </ion-item>
      } @else {
        @if (detail.dateAdded && detail.price) {
          <ion-item>
            <ion-label position="stacked" class="read">{{
              (detail.isRecurring
                ? 'shop_dateAddedRecurring'
                : 'shop_dateAdded'
              ) | translate
            }}</ion-label>
            <ion-text>{{ detail.dateAdded | date: 'longDate' }}</ion-text>
          </ion-item>
        }
      }
    </ion-list>
    @if (canCancel) {
      <ion-button fill="clear" (click)="onCancel()"
        >{{ 'shop_cancelSubBtn' | translate
        }}<ion-icon name="close-outline" slot="end"></ion-icon
      ></ion-button>
    }
  </ion-card>
  @if (detail.isExpired && detail.isRecurring) {
    <ion-card class="ion-padding expired-warning">
      <ion-text>{{ 'shop_expiredInfo' | translate }}</ion-text>
    </ion-card>
  }
}
